<app-wizard-side-dialog #dialog i18n-headerText="XTIT|Unified Wizard header title@@organizations.unified-create-application-dialog.title"
                        headerText="Quick Start: App Setup" saveText="Set Up App"
                        headerGlyph="layer-group"
                        [busy]="loading" [validationFn]="validateForm.bind(this)"
                        (save)="onSubmit(ExecutionType.Create)"
                        [contentVisible]="!loading"
                        [isDirty]="form.dirty"
                        [errorText]="errorText" [errorMsg]="errorMsg"
                        (beforeStepChange)="onBeforeStepChange($event)">

    <app-wizard-dialog-step stepId="beforeBegin" title="Before You Begin" status="current"
                            headerGlyph="action-settings" [isValid]="form.controls[STEP_BEGIN_FORM_GROUPS.STEP_BEGIN]?.valid">
        <ng-template #template>
            <app-unified-step-begin [formGroup]="form"></app-unified-step-begin>
        </ng-template>
    </app-wizard-dialog-step>

    <app-wizard-dialog-step stepId="basicInfo" title="Basic Configuration" status="current" [isValid]="form.controls[STEP_SETUP_FORM_GROUPS.STEP_SETUP]?.valid"
                            headerGlyph="action-settings">
        <ng-template #template>
            <app-unified-step-setup [formGroup]="form"></app-unified-step-setup>
        </ng-template>
    </app-wizard-dialog-step>

    <app-wizard-dialog-step stepId="review" title="Review" headerGlyph="accept">
        <ng-template #template>
            <app-unified-step-review [formGroup]="form"></app-unified-step-review>
        </ng-template>
    </app-wizard-dialog-step>
</app-wizard-side-dialog>
